// extracted by mini-css-extract-plugin
export default {"container":"OverviewPanel_container__GH5pX"};